export { default as getCategories } from "./getCategories";
export { default as getMerchantDetails } from "./getMerchantDetails";
export { default as getAddresses } from "./getAddresses";
export { default as getCheckoutInfo } from "./getCheckoutInfo";
export { default as getMenu } from "./getMenu";
export { default as getItemsInCategory } from "./getItemsInCategory";
export { default as getAllItems } from "./getAllItems";
export { default as getUncategorizedItems } from "./getUncategorizedItems";
export { default as submitRecaptchaData } from "./submitRecaptchaData";
export { default as getPhoneConfirmationOtp } from "./getPhoneConfirmationOtp";
export { default as getItemDetails } from "./getItemDetails";
export { default as sendCheckoutOrder } from "./sendCheckoutOrder";
export { default as getCustomerDetails } from "./getCustomerDetails";
export { default as sendNewCustomerNames } from "./sendNewCustomerNames";
export { default as getEmployeesForService } from "./getEmployeesForService";
export { default as getAvailableAppointmentTimes } from "./getAvailableAppointmentTimes";
export { default as sendAppointment } from "./sendAppointment";
export { default as getMerchantPreferences } from "./getMerchantPreferences";
export { default as sendNewCustomerPhoneNumber } from "./sendNewCustomerPhoneNumber";
export { default as sendNewPhoneNumberOtp } from "./sendNewPhoneNumberOtp";
export { default as sendNewCustomerEmail } from "./sendNewCustomerEmail";
export { default as confirmEmailChange } from "./confirmEmailChange";
export { default as refreshCustomerDetails } from "./refreshCustomerDetails";
export { default as refreshOrderHistory } from "./refreshOrderHistory";
export { default as refreshMenu } from "./refreshMenu";
export { default as getOrders } from "./getOrders";
export { default as getAppointments } from "./getAppointments";
export { default as getOrderEstimate } from "./getOrderEstimate";
export { default as getCardOnFile } from "./getCardOnFile";
export { default as saveCardOnFile } from "./saveCardOnFile";
export { default as updateCardOnFile } from "./updateCardOnFile";
export { default as sendFinalizePayment } from "./sendFinalizePayment";
export { default as deleteCardOnFile } from "./deleteCardOnFile";
export { default as refreshCardOnFile } from "./refreshCardOnFile";
export { default as cancelAppointment } from "./cancelAppointment";
export { default as trackGoogleConversion } from "./trackGoogleConversion";
export { default as getRetailPickupTime } from "./getRetailPickupTime";
export { default as getDefaultAddress } from "./getDefaultAddress";
export { default as saveDefaultAddress } from "./saveDefaultAddress";
export { default as getMerchantPaymentConfig } from "./getMerchantPaymentConfig";
export { default as getMerchantGeo } from "./getMerchantGeo";
export { default as getPolicies } from "./getPolicies";
export { default as sendLoginUsername } from "./sendLoginUsername";
export { default as sendLoginPasscode } from "./sendLoginPasscode";

export const apiUrl =
  (process.env.ENV === "dev" ? "http" : "https") +
  `://${process.env.API}:${process.env.PORT}/api`;
